let timeout;

export function homeArchiveScrollover() {
  const mainContainer = document.querySelector('#site-content');
  const homeArchive = document.querySelector('.home-project-list-wrapper');
  const projectFeatures = document.querySelectorAll('.project-feature');

  if (mainContainer.getAttribute('data-barba-namespace') === 'home') {
    const homeArchiveHeight = homeArchive.offsetHeight;
    const homeArchivePos = homeArchive.getBoundingClientRect().top;

    if (timeout) {
      window.cancelAnimationFrame(timeout);
    }
    timeout = window.requestAnimationFrame(function() {
      projectFeatures.forEach(el => {
        el.style.marginTop = Math.min(Math.max(homeArchivePos * -1, 0), homeArchiveHeight + 100) + 'px';
      });
    });
  }
}

//let mainContainer;
let homeArchive;
let projectFeatures;
let homeArchiveHeight;

export function updateHomeScrollInfo() {
  //mainContainer = document.body.querySelector('#site-content');
  homeArchive = document.body.querySelector('.home-project-list-wrapper');
  projectFeatures = document.body.querySelectorAll('.project-feature');
  homeArchiveHeight = homeArchive.offsetHeight;
}

export async function homeScroll() {
  await new Promise(resolve => window.requestAnimationFrame(resolve));
  // if (mainContainer.getAttribute('data-barba-namespace') === 'home') {
    const homeArchiveClientRect = homeArchive.getBoundingClientRect() || null;
    const homeArchivePos = homeArchiveClientRect.top || 0;
    const homeArchiveBot = homeArchiveClientRect.bottom || 0;
    const aboveFold = window.innerHeight / 2 < homeArchiveBot && homeArchiveClientRect;

    document.body.classList.toggle('above-fold', aboveFold);

    projectFeatures.forEach(function(el) {
      el.style.marginTop = Math.min(Math.max(homeArchivePos * -1, 0), homeArchiveHeight + 100) + 'px';
    });
  // }
}
